/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Component imports
import { Button, Result } from 'antd';

// Misc imports
import AppLogoFull from '../assets/logo-full.svg';
import { NAV_ROOT } from '../constants/navigation';

const PageNotFoundScreen = () => {
  const { t } = useTranslation();

  return (
    <Result
      title="404"
      icon={<img src={AppLogoFull} alt="logo" style={{ maxHeight: 200, width: 250 }} />}
      subTitle={t('Sorry, the page you visited does not exist.')}
      extra={
        <Link to={NAV_ROOT}>
          <Button type="primary" size="large">
            {t('Go to Home')}
          </Button>
        </Link>
      }
    />
  );
};

export default PageNotFoundScreen;
